import { render, staticRenderFns } from "./QuizLink.vue?vue&type=template&id=0359b7dc&scoped=true&"
import script from "./QuizLink.vue?vue&type=script&lang=js&"
export * from "./QuizLink.vue?vue&type=script&lang=js&"
import style0 from "./QuizLink.vue?vue&type=style&index=0&id=0359b7dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0359b7dc",
  null
  
)

export default component.exports